import { resources } from "@constants/hardcoded-strings";
import {
    AXNUIContent
} from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingMobileCompletePageValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingMobileCompletePageValidationErrors = (
    isUsingThemedUI: boolean,
    showIncodeFlowTabs: boolean,
    axnuiContent: AXNUIContent
): ThemingMobileCompletePageValidationErrors => {
    let count = 0;
    let titleError = null;
    let successMessageError = null;
    let errorMessageError = null;

    if (isUsingThemedUI && showIncodeFlowTabs) {
        if (!axnuiContent.mobileComplete.title) {
            count += 1;
            titleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.mobileComplete.successMessage) {
            count += 1;
            successMessageError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.mobileComplete.errorMessage) {
            count += 1;
            errorMessageError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
    }

    return {
        titleError,
        successMessageError,
        errorMessageError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.mobileCompletePage.tabName}
            errorCount={count}
        />
    };
};